import { z } from "zod";
export const RoomTypeSchema = z.enum(["single", "double", "triple", "family", "suite"]);
export const AccommodationVenueSchema = z.object({
    id: z.string(),
    weddingId: z.string(),
    name: z.string().min(1),
    address: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    website: z.string().url().nullable().optional(),
    notes: z.string().nullable().optional(),
    // ── New, all optional + nullable so existing docs validate unchanged ──
    /** e.g. "5★ Boutique" */
    category: z.string().nullable().optional(),
    /** Distance to the venue in km. */
    distanceKm: z.number().nonnegative().nullable().optional(),
    /** Hex color (#RRGGBB) used as the venue's accent in the UI. */
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/)
        .nullable()
        .optional(),
    /** Short tagline displayed under the venue name (distinct from longer `notes`). */
    note: z.string().nullable().optional(),
    /** ISO datetime — booking deadline for the room block. */
    deadlineDate: z.string().datetime().nullable().optional(),
    /** Default price per night for this venue, in PLN. Rooms may override. */
    pricePerNight: z.number().nonnegative().nullable().optional(),
    /** Length of the booked room block, in nights. Defaults to 1 when unset. */
    nights: z.number().int().min(1).max(14).nullable().optional(),
    perks: z.array(z.string()).nullable().optional(),
    /** Contact person at the venue (separate from the optional `phone`). */
    contact: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const AccommodationRoomSchema = z.object({
    id: z.string(),
    venueId: z.string(),
    weddingId: z.string(),
    name: z.string().min(1),
    type: RoomTypeSchema,
    bedCount: z.number().int().min(1).default(1),
    /** Per-room override of the venue's `pricePerNight`. Null → inherit venue rate. */
    pricePerNight: z.number().nonnegative().nullable().optional(),
    /** Guest IDs assigned to this room (including plus-ones/children counting as heads). */
    guestIds: z.array(z.string()).default([]),
    notes: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
